import { BeeMark } from "./BeeLogo";

const WORDS = ["Faith", "Nourishment", "Community", "Gardening", "Restoration", "Sisterhood", "Hope", "Vocational Training"];

export const Marquee = ({ dark = false }) => {
  const row = [...WORDS, ...WORDS];
  return (
    <div
      data-testid="values-marquee"
      className={`overflow-hidden border-y py-5 ${dark ? "border-white/10 bg-garden-dark" : "border-garden/10 bg-pollen-soft"}`}
      aria-hidden="true"
    >
      <div className="marquee-track items-center gap-16 pr-16">
        {row.map((w, i) => (
          <span key={i} className="flex items-center gap-16 whitespace-nowrap">
            <span className={`font-serif text-2xl italic sm:text-3xl ${dark ? "text-pollen-soft/90" : "text-garden"}`}>{w}</span>
            <BeeMark className="h-6 w-6 shrink-0 opacity-70" />
          </span>
        ))}
      </div>
    </div>
  );
};
